import React from "react";
import "../styles/Impressum.css";
import { Link } from "react-router-dom";
import logo from "../assets/skilt-technical-logo.png";

function Impressum() {
  return (
    <section className="impressum">
      <div className="impressum-container">

        <Link to="/">
          <img 
            src={logo} 
            alt="Skilt Technical" 
            className="impressum-logo"
          />
        </Link>

        <h1>Impressum</h1>

        <h2>Angaben gemäß § 5 TMG</h2>

        <p>
          Skilt Technical UG (haftungsbeschränkt)<br/>
          Gubener Str. 36A<br/>
          03149 Forst (Lausitz)
        </p>

        <h2>Vertreten durch</h2>

        <p>
          Geschäftsführerin<br/>
          Rebecca Stelter
        </p>

        <h2>Kontakt</h2>

        <p>
          E-Mail: info@skilt.app
        </p>

        <h2>Registereintrag</h2>

        <p>
          HRB 19564
        </p>

{/*         <h2>Umsatzsteuer-ID</h2>

        <p>
          wird nach Erteilung ergänzt
        </p> */}

        <h2>Streitbeilegung</h2>

        <p>
          Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

      </div>
    </section>
  );
}

export default Impressum;